    function moneyFormat() {
        $('.format-money').each(function () {
            var num = parseFloat($(this).attr('value'));
            var price = Number.prototype.toFixed.call(parseFloat(num) || 0, 2),
                //replace "." to ","
                price_sep = price.replace(/(\D)/g, ","),
                //add space
                price_sep = price_sep.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
            $(this).text(price_sep);
        });

        /*        < !--Money Format Int-- >*/
        $(".format-money-int").each(function () {
            function prettify(num) {
                var n = num.toString();
                var m = n.replace(/(\D)/g, ",");
                var separator = " ";
                return m.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + separator);
            }
            var val = $(this).attr("value");
            $(this).text(prettify(val));
        });
    }
;
    document.addEventListener("DOMContentLoaded", function () {
        const currentUrl = window.location.href;

        document.getElementById("share-url").value = currentUrl;

        const encodedUrl = encodeURIComponent(currentUrl);

        const shareTargets = {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
            twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
            whatsapp: `https://wa.me/?text=${encodedUrl}`,
            viber: `viber://forward?text=${encodedUrl}`,
            email: `mailto:?subject=Check this Ad!&body=${encodedUrl}`,
            sms: `sms:?body=${encodedUrl}`
        };

        document.querySelector(".facebook").closest("a").href = shareTargets.facebook;
        document.querySelector(".twitter").closest("a").href = shareTargets.twitter;
        document.querySelector(".whatsapp").closest("a").href = shareTargets.whatsapp;
        document.querySelector(".viber").closest("a").href = shareTargets.viber;
        document.querySelector(".email").closest("a").href = shareTargets.email;
        document.querySelector(".sms").closest("a").href = shareTargets.sms;
    });
;
    document.querySelector(".btn-address-copy").addEventListener("click", function () {
        const input = document.getElementById("share-url");

        navigator.clipboard.writeText(input.value);

        document.querySelector(".copy-success").style.display = "block";

        setTimeout(() => {
            document.querySelector(".copy-success").style.display = "none";
        }, 2000);
    });
